module.exports = __webpack_public_path__ + "img/food-app.deb8d92f.png";